import { useEffect, useState } from 'react';
import { fetchCountries } from 'services/api/invoicing';
import { COUNTRY_OPTIONS } from 'constants/countries';

interface SelectOption {
  value: string;
  label: string;
}

/**
 * Country <select> options for the invoicing forms. Loads the authoritative
 * list from GET /invoicing/countries (matches the BE's ISO-3166 validation);
 * falls back to the bundled ISO-3166 list until/if the request fails.
 */
export const useCountryOptions = (lang: 'en' | 'de' = 'en'): SelectOption[] => {
  const [options, setOptions] = useState<SelectOption[]>(COUNTRY_OPTIONS);

  useEffect(() => {
    let cancelled = false;

    fetchCountries(lang)
      .then(list => {
        if (!cancelled && list.length) {
          setOptions(list.map(c => ({ value: c.code, label: c.name })));
        }
      })
      .catch(() => undefined);

    return () => {
      cancelled = true;
    };
  }, [lang]);

  return options;
};
